import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class ContactQueryCriteriaClass extends BaseCriteriaModel {
  // Hdr
  name?: Optional<string> = Optional.empty();
  key_guid?: Optional<string> = Optional.empty();

  //for extension & line
  ext_param_code?: Optional<string> = Optional.empty();
  ext_param_name?: Optional<string> = Optional.empty();
  ext_param_type?: Optional<string> = Optional.empty();
  ext_value_string?: Optional<string> = Optional.empty();
  ext_value_numeric?: Optional<number> = Optional.empty();
  ext_value_datetime?: Optional<string> = Optional.empty();
  line_param_code?: Optional<string> = Optional.empty();
  line_param_name?: Optional<string> = Optional.empty();
  line_param_type?: Optional<string> = Optional.empty();
  line_value_string?: Optional<string> = Optional.empty();
  line_value_numeric?: Optional<number> = Optional.empty();
  line_value_datetime?: Optional<string> = Optional.empty();
}

export class ContactCriteriaModelQuery {
  query = '';

  constructor(contactCriteriaModel: ContactQueryCriteriaClass) {

    if (!contactCriteriaModel) {
      return;
    }

    this.query += contactCriteriaModel.name.filter(x => x !== '').map(x => '&name=' + x).orElse('');
    this.query += contactCriteriaModel.key_guid.filter(x => x !== '').map(x => '&key_guid=' + x).orElse('');

    this.query += contactCriteriaModel.ext_param_code.filter(x => x !== '').map(x => '&ext_param_code=' + x).orElse('');
    this.query += contactCriteriaModel.ext_param_name.filter(x => x !== '').map(x => '&ext_param_name=' + x).orElse('');
    this.query += contactCriteriaModel.ext_param_type.filter(x => x !== '').map(x => '&ext_param_type=' + x).orElse('');
    this.query += contactCriteriaModel.ext_value_string.filter(x => x !== '').map(x => '&ext_value_string=' + x).orElse('');
    this.query += contactCriteriaModel.ext_value_numeric.filter(x => x !== null).map(x => '&ext_value_numeric=' + x).orElse('');
    this.query += contactCriteriaModel.ext_value_datetime.filter(x => x !== '').map(x => '&ext_value_datetime=' + x).orElse('');
    this.query += contactCriteriaModel.line_param_code.filter(x => x !== '').map(x => '&line_param_code=' + x).orElse('');
    this.query += contactCriteriaModel.line_param_name.filter(x => x !== '').map(x => '&line_param_name=' + x).orElse('');
    this.query += contactCriteriaModel.line_param_type.filter(x => x !== '').map(x => '&line_param_type=' + x).orElse('');
    this.query += contactCriteriaModel.line_value_string.filter(x => x !== '').map(x => '&line_value_string=' + x).orElse('');
    this.query += contactCriteriaModel.line_value_numeric.filter(x => x !== null).map(x => '&line_value_numeric=' + x).orElse('');
    this.query += contactCriteriaModel.line_value_datetime.filter(x => x !== '').map(x => '&line_value_datetime=' + x).orElse('');

    this.query += '&status=' + contactCriteriaModel.status;
    this.query += '&orderBy=' + contactCriteriaModel.orderBy;
    this.query += '&order=' + contactCriteriaModel.order;
    this.query += '&offset=' + contactCriteriaModel.offset + '&limit=' + contactCriteriaModel.limit;
  }
}
